import { render } from "./myHonors.vue?vue&type=template&id=ff02b356&scoped=true"
import script from "./myHonors.vue?vue&type=script&lang=js"
export * from "./myHonors.vue?vue&type=script&lang=js"

import "./myHonors.vue?vue&type=style&index=0&id=ff02b356&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff02b356"]])

export default __exports__